import { noticePoints } from "@/mocks/home";

export default function Notice() {
  return (
    <section id="notice" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-10 max-w-3xl">
          <span className="font-label text-xs tracking-widest text-primary-600">NOTICE</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            说明与浏览提示
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            在开始浏览之前，有几件事值得先了解。它们关系到你看到的信息是否准确，也关系到观看时的体验与状态。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {noticePoints.map((point) => (
            <div key={point.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                <i className={point.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{point.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}